import each from 'lodash/each';
import assertHasProperty from './assertHasProperty';

export default (object, ...args) => each(args, (argument) => assertHasProperty(object, argument));
